module.exports = __webpack_public_path__ + "img/bg03.3303fb49.jpg";